import { rateLimitingEnabled } from '@/utils';
import { canAccess, canAccessFeature, includedInPaidPurchaseOrders } from '@/utils/acl';

const Plugin = {
  install(app) {
    if (this.installed) return;

    this.installed = true;
    this.app = app;

    app.config.globalProperties.$access = (store, resourceType, resourceId) => {
      if (resourceType === 'feature') {
        // This is kind of a retrofit to better utilize features within the acl system
        // canAccessFeature will check the purchase orders linked to active purchase receipts
        // to determine if a feature (resourceId in this case) is included in said purchase orders
        return canAccessFeature(store, resourceId);
      }
      const resource = this.getResource(store, resourceType, resourceId);
      if (!resource) {
        return false;
      }

      let isRateLimited = false;
      const globalProps = this.app.config.globalProperties;
      if (globalProps.$apptimize) {
        isRateLimited = rateLimitingEnabled({ store, apptimize: globalProps.$apptimize, analytics: globalProps.$analytics });
      }
      const rateLimitableCatTypes = this.rateLimitableCatTypes(store);
      if (isRateLimited && resourceType === 'category' &&  rateLimitableCatTypes.includes(resource.categoryTypeId)) {
        const userHasPurchasedResource = includedInPaidPurchaseOrders(store, resource);
        if (userHasPurchasedResource) {
          return true;
        }

        const currentUserCredits = store.getters['user/rateLimitCredits'];
        return currentUserCredits > 0;
      }

      // for user quizzes automatically return true
      if (resourceType === 'category') {
        const userQuizCategoryType =
          store.getters['categoryTypes/userQuizCategoryType'];
        if (
          userQuizCategoryType &&
          resource.categoryTypeId === userQuizCategoryType.id
        ) {
          return true;
        }
      }

      return canAccess(store.getters['session/currentUser'], resource);
    };
  },

  rateLimitableCatTypes(store) {
    const flashcardCategoryTypes = (store.getters[
      'categoryTypes/multipleChoiceCategoryTypes'
    ] || []).map((ct) => ct.id);
    const quizCategoryTypes = (store.getters[
      'categoryTypes/quizCategoryTypes'
    ] || []).map((ct) => ct.id);
    const terminologyCatTypes = (store.getters[
      'categoryTypes/terminologyCategoryTypes'
    ] || []).map((ct) => ct.id);
    return [
      ...flashcardCategoryTypes,
      ...quizCategoryTypes,
      ...terminologyCatTypes,
    ].filter((a) => a);
  },

  getResource(store, type, id) {
    let getter;
    switch (type) {
      case 'category':
        getter = 'categories/categories';
        break;
      case 'attachment':
        getter = 'attachments/get';
        break;
      case 'learningModule':
        getter = 'learningModules/get';
        break;
      case 'appDashboard':
        getter = 'dashboards/get';
        break;
      case 'navigationItem':
        getter = 'navigationItems/navigationItems';
        break;
      default:
        break;
    }
    if (getter) {
      return store.getters[getter][id];
    } else {
      return {};
    }
  },
};

export default Plugin;
